module.exports = __webpack_public_path__ + "static/media/five.8e06b88d.svg";